import kubernetes from "../../../../src/collections/news/2020/2020-10-29-kubernetes-evolves-into-an-enterprise-platform.md/kubernetes-platform.webp";
import * as React from 'react';
export default {
  kubernetes,
  React
};